__turbopack_context__.v({
  "tabsContainer": "listTabs-module-scss-module__vP-OwG__tabsContainer",
});
